module.exports = __webpack_public_path__ + "static/industrial-ff20f150e5c98959fd650e8ed7f1b7a0.jpg";